import { useEffect } from 'react';
import { useAppSelector } from 'redux/hooks';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import { B4rTsuukaAbTestPattern } from 'pages/DodaFront/View/JobSearchList/types/analytics';
import { RecommendTypes } from '@doda/common/src/constants/urls';
import { measureB4rTsuukaRecommend } from 'pages/DodaFront/View/JobSearchList/logics/b4rTsuukaRecommend';

/**
 * Custom hook to measure B4R Tsuuka Recommend AB Test
 * DODASITE-17171 求人一覧_応募B4R VS B4R通過モデル
 *
 * This hook handles the analytics measurement for the B4R recommendation AB test.
 * It fires measurement when Adobe Analytics script is loaded and the conditions are met.
 *
 * @param recommendType - The type of recommendation
 * @param b4rTsuukaABTestPattern - AB test pattern (ORIGINAL or TEST)
 */
export const useB4rTsuukaRecommendMeasure = (
  recommendType: RecommendTypes | undefined,
  b4rTsuukaABTestPattern: B4rTsuukaAbTestPattern
): void => {
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);

  useEffect(() => {
    measureB4rTsuukaRecommend(
      recommendType,
      b4rTsuukaABTestPattern,
      isAdobeScript
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdobeScript, recommendType]);
};
